// extracted by mini-css-extract-plugin
export default {"media":"media_media__8a-iS","backgroundimageMedia":"media_backgroundimageMedia__wiNs2","border":"media_border__dhyKp"};